import { render, staticRenderFns } from "./wxwl-fuwu.vue?vue&type=template&id=56b90ef0"
import script from "./wxwl-fuwu.vue?vue&type=script&lang=js"
export * from "./wxwl-fuwu.vue?vue&type=script&lang=js"
import style0 from "./wxwl-fuwu.vue?vue&type=style&index=0&id=56b90ef0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports